var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-row",
        { attrs: { gutter: 15 } },
        [
          _c("el-col", { attrs: { sm: 24, md: 24 } }, [
            _c("p", [
              _vm._v(
                "Your submission was saved successfully. Your form reference id is "
              ),
              _c("strong", [_vm._v(_vm._s(_vm.formId))]),
              _vm._v(". "),
            ]),
            _vm._v(" "),
            _vm.paymethod == "bank"
              ? _c(
                  "div",
                  [
                    _vm._v(
                      "After we receive your submission and check all materials an invoice will be sent to your email.\n                Please forward at "
                    ),
                    _c(
                      "a",
                      {
                        attrs: { href: "mailto:contact@globaldesignnews.com" },
                      },
                      [_vm._v("contact@globaldesignnews.com")]
                    ),
                    _vm._v(
                      "\n                the bank transfer receipt adding the ID of your entry as reference number."
                    ),
                    _c("BR"),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "bankdocument",
                        attrs: {
                          href: "pdf/banktransfer_fh.pdf",
                          target: "_blank",
                        },
                      },
                      [
                        _vm._v(
                          "Download Bank payment\n                    details"
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _c("div", [
                  _vm._v(
                    "After we receive your submission and check all materials an invoice will be sent to your email."
                  ),
                ]),
            _vm._v(" "),
            _c("p", [
              _vm._v(
                "If you wish to apply for more than one projects to our award program, please return to the "
              ),
              _c(
                "a",
                {
                  attrs: { href: "#" },
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      return _vm.refreshPage.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("Future House Award page")]
              ),
              _vm._v(".\n            "),
            ]),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }